import ar_ae from './ar-AE.json.js';
import ar_sa from './ar-SA.json.js';
import cs_cz from './cs-CZ.json.js';
import da_dk from './da-DK.json.js';
import de_de from './de-DE.json.js';
import el_gr from './el-GR.json.js';
import en_us from './en-US.json.js';
import es_es from './es-ES.json.js';
import es_mx from './es-MX.json.js';
import es_pr from './es-PR.json.js';
import fi_fi from './fi-FI.json.js';
import fr_ca from './fr-CA.json.js';
import fr_fr from './fr-FR.json.js';
import he_il from './he-IL.json.js';
import hr_hr from './hr-HR.json.js';
import hu_hu from './hu-HU.json.js';
import is_is from './is-IS.json.js';
import it_it from './it-IT.json.js';
import ja_jp from './ja-JP.json.js';
import ko_kr from './ko-KR.json.js';
import lt_lt from './lt-LT.json.js';
import nl_nl from './nl-NL.json.js';
import no_no from './no-NO.json.js';
import pl_pl from './pl-PL.json.js';
import pt_pt from './pt-PT.json.js';
import ro_ro from './ro-RO.json.js';
import sl_si from './sl-SI.json.js';
import sv_se from './sv-SE.json.js';
import th_th from './th-TH.json.js';
import tr_tr from './tr-TR.json.js';
import zh_cn from './zh-CN.json.js';
import zh_hk from './zh-HK.json.js';
import zh_tw from './zh-TW.json.js';

/* eslint-disable camelcase */

/**
 * Gets the translation for a model for a locale
 * @param {string} locale - en_US, fr_CA
 * @return {object} localized translation object
 */
var translationMappings = function translationMappings(locale) {
  var translations = {
    ar_ae: ar_ae,
    ar_sa: ar_sa,
    cs_cz: cs_cz,
    da_dk: da_dk,
    de_de: de_de,
    el_gr: el_gr,
    en_us: en_us,
    es_es: es_es,
    es_mx: es_mx,
    es_pr: es_pr,
    fi_fi: fi_fi,
    fr_ca: fr_ca,
    fr_fr: fr_fr,
    he_il: he_il,
    hr_hr: hr_hr,
    hu_hu: hu_hu,
    is_is: is_is,
    it_it: it_it,
    ja_jp: ja_jp,
    ko_kr: ko_kr,
    lt_lt: lt_lt,
    nl_nl: nl_nl,
    no_no: no_no,
    pl_pl: pl_pl,
    pt_pt: pt_pt,
    ro_ro: ro_ro,
    sl_si: sl_si,
    sv_se: sv_se,
    th_th: th_th,
    tr_tr: tr_tr,
    zh_cn: zh_cn,
    zh_hk: zh_hk,
    zh_tw: zh_tw,
    // Add secondary languages that use translations from other locales
    /* EMEA */
    ar_qa: ar_ae,
    de_at: de_de,
    de_ch: de_de,
    de_lu: de_de,
    es_cl: es_mx,
    fr_be: fr_fr,
    fr_ch: fr_fr,
    fr_lu: fr_fr,
    it_ch: it_it,
    nl_be: nl_nl,
    /* ASIA/PACIFIC */
    zh_mo: zh_hk
  };
  if (translations[locale === null || locale === void 0 ? void 0 : locale.toLowerCase()]) {
    return translations[locale === null || locale === void 0 ? void 0 : locale.toLowerCase()];
  }
  return en_us;
};

export { translationMappings as default };
